import RespuestaReadDto from "./RespuestaReadDto";

class PreguntaReadDto {
  public id: number;
  public question: string;
  public answers: RespuestaReadDto[];
}

export default PreguntaReadDto;
